import React, { Component } from 'react';
import { mixin, RefluxMixin } from '../Util';
import CourseStore from '../stores/Course';
import CourseActions from '../actions/Course';
import CourseDetail from '../components/Route/Course/Detail';
import Loader from '../components/Material/Loader';

class CourseDetailContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStore(CourseStore);
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    CourseActions.findById(this.props.params.courseId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.routeParams.courseId !== nextProps.routeParams.courseId) {
      CourseActions.findById(nextProps.routeParams.courseId);
    }
  }

  render() {
    const { course } = this.state;
    if (!course || !course.id) {
      return <Loader />;
    }
    return (
      <CourseDetail
        key={course.id}
        course={course}
        onClose={this.props.router.goBack}
      />
    );
  }
}

export default CourseDetailContainer;



// WEBPACK FOOTER //
// ./src/js/containers/CourseDetailContainer.js